import React from 'react';
import VideoCollectionItem from './VideoCollectionItem';
import { StyleSheet, css } from 'aphrodite/no-important';

const cssMediaItemSettings = {
	desktop: { item: { width: '360px' }},
	laptop: { item: { width: '300px' }},
	tablet: { item: { width: '223px' }},
	mobile: {
		item: { width: '46%' },
		firstItem: {
			width: '100%'
		},
		firstItemMeta: {
			marginLeft: '10px',
			marginRight: '10px'
		}
	}
};

class ThreeItems extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const posts = this.props.posts.slice(0, 3);
		let idx = 0;
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let isShow = this.props.show ? this.props.show : false;
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				{posts.map(p => (<VideoCollectionItem post={p} key={key++} isShow={ isShow } mediaSettings={cssMediaItemSettings} outerIndex={outerIndex++} innerIndex={idx++} utmObj={utmObj} />))}
			</div>
		);
	}
}

export default ThreeItems;



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/ThreeItems.js